export default __webpack_public_path__ + "static/skyweaverbg-eca5faf6616a34471fc95554b331f50a.png";